export const HYDRA_DEFAULT_ROUTE = 'default';

export function normalizeHydraRoute(basePath: string, route: string | null | undefined) {
    if (!route || route === basePath || route === `${basePath}?`) {
        return HYDRA_DEFAULT_ROUTE;
    }

    return route;
}

export function buildResourceListQueryKey(
    resourceKey: string,
    basePath: string,
    route: string | null | undefined,
) {
    return [resourceKey, 'list', normalizeHydraRoute(basePath, route)];
}

export interface HydraView {
    'hydra:next'?: string | null;
    'hydra:previous'?: string | null;
}

export function getHydraPagination(view: HydraView | null | undefined) {
    const nextRoute = view?.['hydra:next'] ?? null;
    const previousRoute = view?.['hydra:previous'] ?? null;

    return {
        nextRoute,
        previousRoute,
        hasNextPage: Boolean(nextRoute),
        hasPreviousPage: Boolean(previousRoute),
    };
}

export interface HydraPaginationState {
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
}

export interface HydraPaginationButtonPropsInput {
    pagination: HydraPaginationState | null | undefined;
    loading: boolean;
    page: number;
    rowsPerPage: number;
    totalItems: number;
}

export function getHydraPaginationButtonProps({
    pagination,
    loading,
    page,
    rowsPerPage,
    totalItems,
}: HydraPaginationButtonPropsInput) {
    return {
        nextIconButtonProps: {
            disabled: loading || !pagination?.hasNextPage,
        },
        backIconButtonProps: {
            disabled: loading || (!pagination?.hasPreviousPage && page === 0),
        },
        rowsPerPage,
        count: totalItems,
    };
}
